const titleStyle = [
  'color: #38bdf8',
  'background: #0f172a',
  'font-size: 16px',
  'font-weight: bold',
  'padding: 8px 16px',
  'border-radius: 6px',
].join(';');

const bodyStyle = 'color: #94a3b8; font-size: 12px;';
const linkStyle = 'color: #0ea5e9; font-size: 12px; font-weight: bold;';

console.log('%c👋 Hey there, curious dev!', titleStyle);
console.log('%cLike what you see? Check out the source code here:', bodyStyle);
console.log('%chttps://github.com/DimasAswito', linkStyle);
